"use client"
import posthog from "posthog-js"
import { PostHogProvider } from "posthog-js/react"
import type React from "react"
import { useMemo } from "react"

export function PHProvider({ children }: { children: React.ReactNode }) {
  const posthogClient = useMemo(() => {
    const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST
    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY

    if (!(posthogKey && posthogHost)) {
      return undefined
    }

    return (
      posthog.init(posthogKey, {
        api_host: posthogHost,
        capture_pageview: true,
        session_recording: {
          recordCrossOriginIframes: true,
        },
      }) || undefined
    )
  }, [])

  if (!posthogClient) {
    return <>{children}</>
  }

  return <PostHogProvider client={posthogClient}>{children}</PostHogProvider>
}
